import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const getFaqList = createAsyncThunk(
    "getFaqList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/faq/faq-list?page=${body.page}&search=${body.search}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

export const FaqSlice = createSlice({
    name: "FaqSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getFaqList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getFaqList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(getFaqList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default FaqSlice.reducer;
